export default {
  title: 'Deweloperzy',
  subtitle: 'Klucze API, webhooki i historia dostaw dla Twojej integracji z Partner API.',
  no_account: 'Brak konta Partner API — skontaktuj się z Foodamigos, aby je utworzyć.',
  no_account_manage: 'Brak konta Partner API — utwórz jedno, aby zacząć wydawać klucze.',
  buttons: {
    new_account: 'Nowe konto',
    edit_account: 'Edytuj konto',
    docs: 'Dokumentacja API',
  },
  tabs: {
    api_keys: 'Klucze API',
    webhooks: 'Webhooki',
    deliveries: 'Dostawy',
  },
  toasts: {
    load_error: 'Nie udało się wczytać kont Partner API.',
  },
};
